import { v4 as uuidv4 } from "uuid";
import {
  SET_CART,
  SET_LOADING,
  DISABLED_NUMBERS,
  SET_GUID,
} from "./rifaActions";

const RIFA_INITIAL_STATE = {
  loading: false,
  cart: [],
  disabledNumbers: {},
  strGuidWeb: uuidv4(),
};

export default (state = RIFA_INITIAL_STATE, action) => {
  switch (action.type) {
    case DISABLED_NUMBERS:
      return {
        ...state,
        disabledNumbers: action.payload.disabledNumbers || {},
      };
    case SET_CART:
      return {
        ...state,
        cart: action.payload.cart || [],
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload || !state.loading,
      };
    case SET_GUID:
      return {
        ...state,
        strGuidWeb: action.payload.strGuidWeb,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/rifa/rifaReducer.js